
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {CounterInfo} from './CounterInfo';
import {FieldModelCounterInfo} from './CounterInfo';
import {SymbolCounterInfo} from './SymbolCounterInfo';
import {FieldModelSymbolCounterInfo} from './SymbolCounterInfo';

/**
 * FeedModuleInfo struct
 */
class FeedModuleInfo {
  /**
   * Initialize struct
   * @param {!CounterInfo=} tickInfo
   * @param {!Array=} topSymbolTickInfo
   * @constructor
   */
  constructor (tickInfo = new CounterInfo(), topSymbolTickInfo = []) {
    this.TickInfo = tickInfo
    this.TopSymbolTickInfo = topSymbolTickInfo
  }

  /**
   * Copy struct (shallow copy)
   * @this {!FeedModuleInfo}
   * @param {!FeedModuleInfo} other Other struct
   * @returns {!FeedModuleInfo} This struct
   */
  copy (other) {
    if (other.TickInfo != null) {
      this.TickInfo = CounterInfo.fromObject(other.TickInfo)
    } else {
      this.TickInfo = null
    }
    if (other.TopSymbolTickInfo != null) {
      this.TopSymbolTickInfo = []
      for (let item of other.TopSymbolTickInfo) {
        if (item != null) {
          let tempItem
          tempItem = SymbolCounterInfo.fromObject(item)
          this.TopSymbolTickInfo.push(tempItem)
        } else {
          this.TopSymbolTickInfo.push(null)
        }
      }
    } else {
      this.TopSymbolTickInfo = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!FeedModuleInfo}
   * @returns {!FeedModuleInfo} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new FeedModuleInfoModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new FeedModuleInfoModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!FeedModuleInfo}
   * @param {!FeedModuleInfo} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof FeedModuleInfo)) {
      throw new TypeError('Instance of FeedModuleInfo is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!FeedModuleInfo}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      TickInfo: ((this.TickInfo != null) ? this.TickInfo : null),
      TopSymbolTickInfo: ((this.TopSymbolTickInfo != null) ? Array.from(this.TopSymbolTickInfo, item => ((item != null) ? item : null)) : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return FeedModuleInfo.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!FeedModuleInfo} other Object value
   * @returns {!FeedModuleInfo} Created struct
   */
  static fromObject (other) {
    return new FeedModuleInfo().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!FeedModuleInfo}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return FeedModuleInfo.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!FeedModuleInfo}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 76
  }
}

export { FeedModuleInfo };

/**
 * Fast Binary Encoding FeedModuleInfo field model
 */
class FieldModelFeedModuleInfo extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.TickInfo = new FieldModelCounterInfo(buffer, 4 + 4)
    this.TopSymbolTickInfo = new fbe.FieldModelVector(new FieldModelSymbolCounterInfo(buffer, this.TickInfo.fbeOffset + this.TickInfo.fbeSize), buffer, this.TickInfo.fbeOffset + this.TickInfo.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelFeedModuleInfo}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelFeedModuleInfo}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.TickInfo.fbeSize + this.TopSymbolTickInfo.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelFeedModuleInfo}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.TickInfo.fbeExtra + this.TopSymbolTickInfo.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelFeedModuleInfo}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelFeedModuleInfo.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelFeedModuleInfo}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 76
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelFeedModuleInfo}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelFeedModuleInfo}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.TickInfo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TickInfo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TickInfo.fbeSize

    if ((fbeCurrentSize + this.TopSymbolTickInfo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TopSymbolTickInfo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TopSymbolTickInfo.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelFeedModuleInfo}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelFeedModuleInfo}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelFeedModuleInfo}
   * @param {!FeedModuleInfo} fbeValue Default value, defaults is new FeedModuleInfo()
   * @returns {!FeedModuleInfo} FeedModuleInfo value
   */
  get (fbeValue = new FeedModuleInfo()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelFeedModuleInfo}
   * @param {!FeedModuleInfo} fbeValue FeedModuleInfo value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.TickInfo.fbeSize) <= fbeStructSize) {
      fbeValue.TickInfo = this.TickInfo.get()
    } else {
      fbeValue.TickInfo = new CounterInfo()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TickInfo.fbeSize

    if ((fbeCurrentSize + this.TopSymbolTickInfo.fbeSize) <= fbeStructSize) {
      this.TopSymbolTickInfo.get(fbeValue.TopSymbolTickInfo)
    } else {
      fbeValue.TopSymbolTickInfo.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TopSymbolTickInfo.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelFeedModuleInfo}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelFeedModuleInfo}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelFeedModuleInfo}
   * @param {!FeedModuleInfo} fbeValue FeedModuleInfo value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelFeedModuleInfo}
   * @param {FeedModuleInfo} fbeValue FeedModuleInfo value
   */
  setFields (fbeValue) {
    this.TickInfo.set(fbeValue.TickInfo)
    this.TopSymbolTickInfo.set(fbeValue.TopSymbolTickInfo)
  }
}

export { FieldModelFeedModuleInfo };

/**
 * Fast Binary Encoding FeedModuleInfo model
 */
class FeedModuleInfoModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelFeedModuleInfo(this.buffer, 4)
  }

  /**
   * Get the FeedModuleInfo model
   * @this {!FeedModuleInfoModel}
   * @returns {!FieldModelFeedModuleInfo} model FeedModuleInfo model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!FeedModuleInfoModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!FeedModuleInfoModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return FeedModuleInfoModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!FeedModuleInfoModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelFeedModuleInfo.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!FeedModuleInfoModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!FeedModuleInfoModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!FeedModuleInfoModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!FeedModuleInfoModel}
   * @param {!FeedModuleInfo} value FeedModuleInfo value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!FeedModuleInfoModel}
   * @param {!FeedModuleInfo} value FeedModuleInfo value, defaults is new FeedModuleInfo()
   * @return {!object} Deserialized FeedModuleInfo value and its size
   */
  deserialize (value = new FeedModuleInfo()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new FeedModuleInfo(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new FeedModuleInfo(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!FeedModuleInfoModel}
   * @param {!number} prev Previous FeedModuleInfo model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { FeedModuleInfoModel };
